(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.controller('UserWebsiteMessageController', ['$uibModalInstance', UserWebsiteMessageControllerFn]);

    /* controlle for message modal */
    function UserWebsiteMessageControllerFn($uibModalInstance) {
        var vm = this;

        activate();

        // cancel modal
        vm.close = function () {
            $uibModalInstance.dismiss("abort");
        };

        /* activation work */
        function activate() {
        }
    }
})();